import { c as _c } from "react/compiler-runtime";
import { AiChatTriggerButton } from 'help-bots/ai-chat';
import { MobileMenu } from 'shared/components/navbar/components/mobile-menu';
import { Notifications } from 'shared/components/navbar/components/notifications';
export function MobileActions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="ml-auto flex shrink-0 items-center gap-1"><AiChatTriggerButton /><Notifications isDesktop={false} /><MobileMenu /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}